import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../../shared/loader/LoaderService';

/**
 * Modern functional HTTP interceptor for showing/hiding loader
 * Uses inject() function instead of constructor injection
 */
export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);

  if (req.url.toLowerCase().includes('GetByClientPoc'.toLowerCase())) {
    return next(req);
  }

  let timeExceeded = false;
  const timeout = setTimeout(() => {
    loaderService.show();
    timeExceeded = true;
  }, 1000);

  return next(req).pipe(
    finalize(() => {
      if (!timeExceeded) {
        clearTimeout(timeout);
      }
      loaderService.hide();
    }),
  );
};
